import React, { useState } from "react";
import {
  OptionContainer,
  OptionContent,
  OptionLabel,
  SettingsOptionContainer,
} from "../../../styles";
import { useTranslation } from "react-i18next";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ReorderablePages from "./ReorderablePages";
import { usePages } from "../../../../../../../features/pages/usePages";
import PagePicker from "../../../../../../../components/ui/page-picker/PagePicker";
import { usePagesStore } from "../../../../../../../stores/use-page-store";

function Manual() {
  const { t } = useTranslation();
  const [pickerKey, setPickerKey] = useState(crypto.randomUUID());

  const { data, selectedTab, updateConfigTab } = usePagesStore((state) => ({
    data: state.data,
    selectedTab: state.getSelectedTab(),
    updateConfigTab: state.updateConfigTab,
  }));

  const onSelect = ({ selectedPage }) => {
    if (
      !selectedPage ||
      !!data.config.tabs[selectedTab].manuallyPicked.find(
        (page) => String(selectedPage.contentId) === String(page.contentId)
      )
    ) {
      return;
    }

    const currentLastPicked =
      data.config.tabs[selectedTab].manuallyPicked.length > 0
        ? data.config.tabs[selectedTab].manuallyPicked[
            data.config.tabs[selectedTab].manuallyPicked.length - 1
          ]
        : null;

    const position = currentLastPicked ? currentLastPicked.position + 1 : 0;

    updateConfigTab({
      value: {
        manuallyPicked: [
          ...data.config.tabs[selectedTab].manuallyPicked,
          {
            id: crypto.randomUUID(),
            position,
            contentId: selectedPage.contentId,
          },
        ],
      },
    });

    setPickerKey(Math.random().toString(36).substring(7));
  };

  const pageQueries = usePages(
    data.config?.tabs[selectedTab]?.manuallyPicked || []
  );

  const selectedPages =
    data.config?.tabs[selectedTab]?.manuallyPicked?.map(
      (page) => page.contentId
    ) || [];

  const removePage = (id) => {
    const newManuallyPicked = data.config.tabs[
      selectedTab
    ].manuallyPicked.filter((page) => page.id !== id);
    updateConfigTab({
      value: {
        manuallyPicked: newManuallyPicked,
      },
    });

    setPickerKey(crypto.randomUUID());
  };

  const resetOrder = (list) => {
    const resetList = list.map((c, index) => {
      const slide = c;
      slide.order = index + 1;
      return slide;
    });
    return resetList;
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return resetOrder(result);
  };

  const reorderPanels = (sourceIndex, targetIndex) => {
    if (sourceIndex === targetIndex) {
      return;
    }
    const manuallyPicked =
      data?.config?.tabs?.[selectedTab]?.manuallyPicked || [];
    const copyOfPages = [...manuallyPicked];
    const items = reorder(copyOfPages, sourceIndex, targetIndex);

    updateConfigTab({
      value: {
        manuallyPicked: items,
      },
    });
  };

  return (
    <>
      <>
        <SettingsOptionContainer>
          <OptionContainer direction="column">
            <OptionLabel>{t("pages")}</OptionLabel>
            <OptionContent full>
              <PagePicker
                key={selectedPages.join("-")}
                selectedPages={selectedPages}
                onSelect={(selectedPage) => onSelect({ selectedPage })}
              />
            </OptionContent>
          </OptionContainer>

          <DndProvider backend={HTML5Backend}>
            <OptionContainer direction="column">
              {pageQueries.map(({ data }, _idx) => (
                <ReorderablePages
                  page={data}
                  index={_idx}
                  reorderPanels={reorderPanels}
                  removePage={removePage}
                />
              ))}
            </OptionContainer>
          </DndProvider>
        </SettingsOptionContainer>
      </>
    </>
  );
}

export default Manual;
